import React,{ useRef} from 'react'
import { Container,Row } from 'react-bootstrap'
import Filters from '../../Components/Filters/Filters'
import HeaderImage from '../../Images/header-video.jpg'
import HeaderImageMobile from '../../Images/header-video-mobile.jpg'
import VideoPanel from '../../Components/VideoPanel'
import VideoPanelNetflix from '../../Components/VideoPanelNetflix'
import Categories from '../../Components/Category/Categories'
import './Home.css'

function Home(props){
    
    const VideoPanelNetflixRef = useRef(null);
   
    return (
      
    <Container fluid>
        <Row>
            <div className="main">
            <div className="d-none d-md-flex"><img className="fadeImage" src={HeaderImage} alt="header"/></div>
            <div className="d-flex d-md-none"><img src={HeaderImageMobile} alt="header"/></div>
            <div className="second">
                <Container>
                    <Row className="title-font">Wellness on Demand</Row>
                    <Row className="subtitle-font">Classes and workshops to nourish mind, body and soul. Anytime. Anywhere.</Row>
                </Container>
            </div>
            </div>
            </Row>
        <Row><Filters reload={(e,search) => VideoPanelNetflixRef.current.getAlert(e,search)}/></Row>
        <Row><Categories reload={(e,search) => VideoPanelNetflixRef.current.getAlert2(e,search)}/></Row>
        <Row><VideoPanelNetflix ref={VideoPanelNetflixRef} reload={(e,search) => VideoPanelNetflixRef.current.getAlert2(e,search)}/></Row>
        
    </Container>
   
    )
}
export default Home